import { Injector } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DynamicFormBaseComponent } from './dynamic-form.base';

export abstract class DialogFormBaseComponent<TDialogModel, TModelModel> extends DynamicFormBaseComponent<TModelModel>{

    // service instance
    private dialogBaseRef: DynamicDialogRef;
    private dialogBaseConfig: DynamicDialogConfig;

    constructor(dialogFormInjector: Injector) {
        super(dialogFormInjector);
        // prepare instance
        this.dialogBaseRef = dialogFormInjector.get(DynamicDialogRef);
        this.dialogBaseConfig = dialogFormInjector.get(DynamicDialogConfig);
    }

    // get dialog data
    get dialogData(): TDialogModel {
        const data = this.dialogBaseConfig.data;
        return data ? data as TDialogModel : null;
    }

    // close dialog
    closeDialog(result: any = null) {
        this.dialogBaseRef.close(result);
    }

}